module.exports = __webpack_public_path__ + "img/birthday.ac9afc33.svg";